// extracted by mini-css-extract-plugin
export var branding = "layout-module--branding--1f7b8";
export var companyAddress = "layout-module--companyAddress--d9cba";
export var container = "layout-module--container--78b04";
export var content = "layout-module--content--2bfc1";
export var expandedCol = "layout-module--expandedCol--a225f";
export var extras = "layout-module--extras--55c48";
export var footer = "layout-module--footer--ad7d0";
export var footerHeadline = "layout-module--footerHeadline--41158";
export var footerLine = "layout-module--footerLine--ffd99";
export var footerLower = "layout-module--footerLower--8f619";
export var hero = "layout-module--hero--39525";
export var item = "layout-module--item--6f5da";
export var link = "layout-module--link--34354";
export var narrowWith = "layout-module--narrowWith--86f3d";
export var siteInfo = "layout-module--siteInfo--30d4f";
export var sites = "layout-module--sites--5da6b";
export var social = "layout-module--social--4a791";
export var solution = "layout-module--solution--70f31";